<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'资讯管理'},{name:'资讯列表',goback:true},{name:'发布资讯'}]" :title="'发布资讯'"/>
            <!-- 表单 -->
            <div class="box">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>资讯标题：</div>
                        <el-input v-model="sendInfo.title" maxlength="80"></el-input>
                    </div>
					<div class="error" v-if="errors['sendInfo.title']">错误提示：{{errors['sendInfo.title']}}</div>

					<div class="child">
					    <div class="name" style=""><span>*</span>封面：</div>
					    <div class="content" >
							<div style="margin-bottom: 5px;">图片仅支持png、jpg，建议高宽比为5:3，尺寸建议250*150px，大小不超过20M</div>
							<upLoad
              :action="'backstage/annex/file'"
							v-model="sendInfo.logo"
							:accept="'image/png,image/jpg,image/jpeg'" 
						:size="20"
            is-need-limit
            :sizeList="[5 / 3]"
            :fixedNumber='[5,3]'
            :autoCropWidth="250"
            :autoCropHeight='150'
							/>
						</div>
					</div>
                    <div class="error" v-if="errors['sendInfo.logo']">错误提示：{{errors['sendInfo.logo']}}</div>

                    <div class="child" style="align-items:flex-start">
                        <div class="name"><span>*</span>资讯简介：</div>
                        <div class="content"><el-input type="textarea" v-model="sendInfo.summary" show-word-limit maxlength="200"></el-input></div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.summary']">错误提示：{{errors['sendInfo.summary']}}</div>

                    <div class="child">
                        <div class="name"><span>*</span>来源：</div>
						<div class="content" ><el-input v-model="sendInfo.source" maxlength="20"></el-input></div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.source']">错误提示：{{errors['sendInfo.source']}}</div>

                    <div class="child">
                        <div class="name"><span>*</span>资讯详情：</div>
                        <div class="content super_prv">
							<!-- <div ref="wangEditor"></div> -->
							<!-- <Editor
								style="width: 500px;min-height: 500px;"
								:EditorCont="sendInfo.content"
								@onEditorChange="onEditorChange"
							></Editor> -->
                            <wangEnduit v-model="sendInfo.content" :quill-index="0" my-editor="editor" :height="500" :upload="handleUploadEditor" />
                            <!-- <wangEnduit @onEditorChange="onEditorChange" :EditorCont="sendInfo.content" style="width: 600px;min-height: 500px;"></wangEnduit> -->
                            <el-button type="primary" class="ml10" @click="onPrivew" plain size="small">预览</el-button>
						</div>
                    </div>
                    <div class="error" v-show="errors['sendInfo.content']">错误提示：{{errors['sendInfo.content']}}</div>

                    <div class="child">
                        <div class="name">附件：</div>
                        <div class="content" >
							<upLoadFiles
							v-model="sendInfo.fileList"
							:action="'/backstage/annex/files'"
							:size="20"
							:accept="'application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword'"
							/>
						</div>
                    </div>
                    <div class="child">
                        <div class="name"></div>
						<div class="content" >
              <div class="singleBtn"><el-button type="primary" size="small" @click="submit">提交审核并发布</el-button></div>
            </div>
                    </div>
                    
                </div>
            </div>
            <el-dialog title="预览" :visible.sync="dialogVisible" width="50%">
            <el-tabs type="border-card">
                    <el-tab-pane>
                        <span slot="label">pc</span>
                        <div v-html="sendInfo.content" class="prv_content isPc"></div>
                    </el-tab-pane>
                    <el-tab-pane>
                        <span slot="label">移动端</span>
                        <div v-html="sendInfo.content" class="prv_content isApp"></div>
                    </el-tab-pane>
            </el-tabs>
                
            </el-dialog>
        </div>
</template>

<script>
import {API} from "@/axios/config";
import breadcrumb from '../../components/breadcrumb';
import upLoadFiles from '../../components/upLoadFiles';
import upLoad from '../../components/upLoads';
import wangEditor from 'wangeditor';
// import wangEnduit from '../../components/wangEnduit';
import wangEnduit from '../../components/Editor/index';
export default {
    components:{
        breadcrumb,
        upLoadFiles,upLoad,wangEnduit
    },
    data(){
        return{
          dialogVisible:false,
            sendInfo:{
                  "content": "",//内容
                  "fileList": [],//附件
                  "newId":null,
                  "source": "",//来源
                  "summary": "",//简介
                  "title": "",//标题
				   logo:'',//logo
            },//提交
            editor:null,//富文本编辑器容器
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
        'sendInfo.title':{
            test:function(){
                if(this.sendInfo.title){
                    return true;
                }else{
                    return false;
                }
            },
            message:'填写资讯标题'
        },
		'sendInfo.logo':{
		    test:function(){
		        if(this.sendInfo.logo){
		            return true;
		        }else{
		            return false;
		        }
		    },
		    message:'请上传logo'
		},
        'sendInfo.summary':{
            test:function(){
                if(this.sendInfo.summary){
                    return true;
                }else{
                    return false;
                }
            },
            message:'填写资讯简介'
        },
        'sendInfo.source':{
            test:function(){
                if(this.sendInfo.source){
                    return true;
                }else{
                    return false;
                }
            },
            message:'填写来源'
        },
        'sendInfo.content':{
            test:function(){
                if(this.sendInfo.content){
                    return true;
                }else{
                    return false;
                }
            },
            message:'填写资讯详情'
        },
    },
    methods:{
      /** 富文本编辑器图片上传 */
    handleUploadEditor(file, callback) {
      const that = this
      const formData = new window.FormData()
      formData.append('file', file)
      // 上传 todu
      that.$axiosz.post(API.UploadsService + "backstage/annex/file", formData).then(res => {

        const {data,code,msg} = res
        if(code === 200){
        const { frontPath, filePath,fileName } = data
        const param = { ...data }
        param.name = fileName
        param.url = frontPath + filePath
        callback(param)
        }
      }).catch(e => {
        // that.$message.info('上传失败')
        that.$alert('上传失败')
        console.log(e)
      })
    },
      onPrivew(){
          if(!this.sendInfo.content || !this.sendInfo.content.trim()){
            this.$message.info('暂无内容不能预览')
            return 
          }
          this.dialogVisible = true
        },
		onEditorChange(val){
		  // let _html=val.container.innerHTML;
		  this.sendInfo.content=val;
		},
		getDetail(id){
			this.$axiosc.get('backstage/news/details/'+id).then((r)=>{
			    if(r.code==200){
			        let dataInfo = r.data;
					let sendInfo={
					      "content": dataInfo.content,//内容
					      "fileList": dataInfo.fileList,//附件
					      "newId":dataInfo.id,
					      "source": dataInfo.source,//来源
					      "summary": dataInfo.summary,//简介
					      "title":dataInfo.title,//标题
						   logo:dataInfo.logo,//logo
					}
					this.sendInfo=sendInfo;
			    }else{
			        this.$alert(r.msg)
			    }
			})
		},
        //提交
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
				this.$axioscBody.post('/backstage/news/saveNews',this.sendInfo).then((r)=>{
				    if(r.code==200){
				        this.$message({
				            type: 'success',
				            message: '发布成功!'
				        });
				        this.$router.back(-1);
				    }else{
				        this.$alert(r.msg);
				    }
				})
            }
        }
    },
    mounted(){
        // this.editor = new wangEditor(this.$refs.wangEditor);
        // this.editor.customConfig.onchange =  (html) => { //通过富文本变化赋值
        //     // html 即变化之后的内容
        //     this.sendInfo.content=html;
        //     this.$vuerify.check(['sendInfo.content']);
        // }
        // this.editor.create();
    },
	created() {
		// if(this.$route.query.id){
		//     this.sendInfo.newId=this.$route.query.id;
		// 	this.getDetail(this.$route.query.id);
		// }
	}
}
</script>

<style lang="scss" scoped>
.warp{
     height:93%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
        .forms{
            max-width: 650px;
            margin: auto;
            transform: translateX(-100px);
            .child{
                .name{
                  width:70px;
                  text-align: right;
                }
                .content{
                    flex: 1;
					/deep/ .ql-container{
						min-height: 410px;
					}
                }
            }
        }
    }
}

</style>
